import { client } from "./_base";

const endpoint = "priceintegration";
const endpointMarket = "priceintegrationMarket";

export const priceintegration = client<PriceIntegrationRules>(endpoint, (item) => item);
export const priceintegrationMarket = client<PriceIntegrationMarket>(endpointMarket, (item) => item);

export enum PriceIntegrationRulesType {
  "PERFECT" = 1,
  "BEST" = 2,
  "NOTHING" = 3,
}

export enum PriceIntegrationRulesStatus {
  "YES" = 1,
  "YES/NO" = 2,
  "NO" = 3,
}

export const RulesType = {
  1: "PERFECT MATCH",
  2: "BEST MATCH",
  3: "NO MATCH",
};

export const RulesStatus = {
  1: "YES",
  2: "YES/NO",
  3: "NO",
};

export const RulesGroup = {
  1: "Main",
  2: "FruitSpec",
  3: "Target",
};

export type PriceIntegrationRules = {
  id: number;
  pii_column: string;
  sys_column: string;
  match: PriceIntegrationRulesType;
  status: PriceIntegrationRulesStatus;
};

export type PriceIntegrationMarket = {
  id: number;
  source_market: string;
  target_market: string;
  created_at?: Date;
  updated_at?: Date;
};

export const RuleStatues = [
  { value: 1, display: "YES" },
  { value: 2, display: "YES/NO" },
  { value: 3, display: "NO" },
];

export const RuleTypes = [
  { value: 1, display: "PERFECT" },
  { value: 2, display: "BEST" },
  { value: 3, display: "NONE" },
];

export const priceIntegrationColumns = [
  { display: "Producer", value: "producer" },
  { display: "Delivery Week", value: "delivery_week" },
  { display: "Cold Week", value: "cold_week" },
  { display: "Variety Code", value: "variety" },
  { display: "Grade Code", value: "grade" },
  { display: "Count Code", value: "count" },
  { display: "Pack Carton", value: "pack_carton" },
  { display: "Mark Code", value: "mark" },
  { display: "Inventory Code", value: "inventory" },
  { display: "Target Country", value: "country" },
  { display: "Target Market", value: "market" },
  { display: "PI Locked", value: "locked" },
  { display: "Shipped Market", value: "shipped_market" },
];

export const priceIntegrationGroups = [
  { display: "Main", value: 1 },
  { display: "Fruit Spec", value: 2 },
  { display: "Target", value: 3 },
];
